/**
 * Stripe hosted payment link for the OG-app Summary PDF export (the €9.99
 * concept report). Behind FLAGS.exportPaymentLink it's offered alongside the
 * in-app card wizard. The price lives on Stripe — this URL is display-only
 * plumbing; swap it for the real €9.99 link.
 *
 * The link is tagged per-click with client_reference_id="summary:<projectId>"
 * so the completed payment routes back (via /checkout/return) to the project's
 * canvas, where the report is regenerated + downloaded. See StudioCheckoutReturn.
 *
 * NOTE: set this link's post-payment redirect (in the Stripe Dashboard) to
 *   https://app.tessa.ai/checkout/return?session_id={CHECKOUT_SESSION_ID}
 * for the loop to close.
 */
export const EXPORT_PAYMENT_LINK = "https://buy.stripe.com/00w3cw2qnaCL8IQckLes005";

export function exportPaymentLinkFor(projectId: string | undefined): string {
  if (!projectId) return EXPORT_PAYMENT_LINK;
  try {
    const u = new URL(EXPORT_PAYMENT_LINK);
    u.searchParams.set("client_reference_id", `summary:${projectId}`);
    return u.toString();
  } catch {
    return EXPORT_PAYMENT_LINK;
  }
}
